(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eunoia-purchase-r01"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-eunoia-purchase-r01]');
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const thumbs = Array.from(section.querySelectorAll('[data-gallery-index]'));
      const heroImage = section.querySelector('.alf-hero-image');
      const imageCount = section.querySelector('[data-gallery-count]');
      const galleryCache = new Map();
      let activeImage = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
      let imageRequest = 0;

      const preloadGalleryImage = (source) => {
        if (!source) return null;
        if (galleryCache.has(source)) return galleryCache.get(source);
        const image = new Image();
        image.decoding = 'async';
        image.src = source;
        galleryCache.set(source, image);
        return image;
      };

      const selectImage = (index) => {
        if (!thumbs.length || !heroImage) return;
        const next = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[next];
        const request = ++imageRequest;
        const highResolutionSource = thumb.dataset.src || '';
        const thumbnailImage = thumb.querySelector('img');
        const immediateSource = thumbnailImage?.currentSrc || thumbnailImage?.src || highResolutionSource;
        activeImage = next;
        heroImage.removeAttribute('srcset');
        heroImage.removeAttribute('sizes');
        if (immediateSource) heroImage.src = immediateSource;
        heroImage.alt = thumb.dataset.alt || '';
        imageCount.textContent = `${String(next + 1).padStart(2, '0')} / ${thumbs.length}`;
        thumbs.forEach((item, itemIndex) => {
          const selected = itemIndex === next;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

        const highResolutionImage = preloadGalleryImage(highResolutionSource);
        const showHighResolutionImage = () => {
          if (request !== imageRequest || activeImage !== next || !highResolutionSource) return;
          heroImage.src = highResolutionSource;
        };
        if (highResolutionImage?.complete && highResolutionImage.naturalWidth > 0) {
          showHighResolutionImage();
        } else {
          highResolutionImage?.addEventListener('load', showHighResolutionImage, { once: true });
        }

        preloadGalleryImage(thumbs[(next + 1) % thumbs.length]?.dataset.src);
        preloadGalleryImage(thumbs[(next - 1 + thumbs.length) % thumbs.length]?.dataset.src);
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => selectImage(activeImage - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectImage(activeImage + 1));
      preloadGalleryImage(thumbs[1]?.dataset.src);
      preloadGalleryImage(thumbs[thumbs.length - 1]?.dataset.src);

      const dialog = section.querySelector('[data-image-dialog]');
      section.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
        if (!dialog || !heroImage) return;
        const zoomedImage = dialog.querySelector('[data-zoomed-image]');
        zoomedImage.src = heroImage.currentSrc || heroImage.src;
        zoomedImage.alt = heroImage.alt;
        dialog.querySelector('[data-zoomed-caption]').textContent = imageCount.textContent;
        dialog.showModal();
      });
      dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());

      let variants = [];
      try {
        variants = JSON.parse(section.querySelector('[data-variant-json]')?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const fitInline = section.querySelector('[data-fit-inline]');
      const factChest = section.querySelector('[data-fact-chest]');
      const sizeFieldset = section.querySelector('.alf-size-option');
      const sizePosition = sizeFieldset ? sizeFieldset.dataset.optionPosition : null;
      const cmToIn = (cm) => (cm / 2.54).toFixed(1);

      const updateFitInline = () => {
        if (!sizePosition) return;
        const selected = section.querySelector(`[data-option-input][data-option-position="${sizePosition}"]:checked`)?.value;
        const row = selected ? Array.from(section.querySelectorAll('[data-size-row]')).find((item) => item.dataset.sizeRow === selected) : null;
        const measurements = row ? { chest: Number(row.dataset.chest), shoulder: Number(row.dataset.shoulder), sleeve: Number(row.dataset.sleeve), length: Number(row.dataset.length) } : null;
        if (fitInline) {
          fitInline.textContent = measurements
            ? `This size measures: chest ${measurements.chest}cm / ${cmToIn(measurements.chest)}in · shoulder ${measurements.shoulder}cm / ${cmToIn(measurements.shoulder)}in · sleeve ${measurements.sleeve}cm / ${cmToIn(measurements.sleeve)}in · length ${measurements.length}cm / ${cmToIn(measurements.length)}in`
            : 'Select a size to see its garment measurements.';
        }
        if (factChest) {
          factChest.textContent = measurements ? `${measurements.chest}cm / ${cmToIn(measurements.chest)}in` : 'Select a size';
        }
      };

      const optionInputs = Array.from(section.querySelectorAll('[data-option-input]'));
      const variantId = section.querySelector('[data-variant-id]');
      const price = section.querySelector('[data-product-price]');
      const comparePrice = section.querySelector('[data-compare-price]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const availability = section.querySelector('[data-availability]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const addLabel = section.querySelector('[data-add-label]');
      const mobileAdd = section.querySelector('[data-mobile-add]');
      const mobileSelection = section.querySelector('[data-mobile-selection]');
      const labels = {
        add: section.dataset.labelAdd,
        sold: section.dataset.labelSold,
        unavailable: section.dataset.labelUnavailable,
        ready: section.dataset.labelReady
      };

      const updateVariant = (syncGallery = true) => {
        const positions = Array.from(new Set(optionInputs.map((input) => Number(input.dataset.optionPosition)))).sort();
        const selected = positions.map((position) => section.querySelector(`[data-option-input][data-option-position="${position}"]:checked`)?.value || '');
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        optionInputs.forEach((input) => {
          const label = input.closest('label');
          if (label) label.classList.toggle('is-active', input.checked);
          if (input.checked) {
            const target = section.querySelector(`[data-option-name="${input.dataset.optionPosition}"]`);
            if (target) target.textContent = input.value;
          }
        });
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (mobileAdd) mobileAdd.disabled = true;
          if (addLabel) addLabel.textContent = labels.unavailable;
          if (availability) availability.textContent = labels.unavailable;
          return;
        }
        if (variantId) variantId.value = variant.id;
        if (price) price.textContent = variant.price;
        if (comparePrice) { comparePrice.textContent = variant.compareAt || ""; comparePrice.hidden = !variant.compareAt; }
        if (mobilePrice) mobilePrice.textContent = variant.price;
        if (mobileSelection) mobileSelection.textContent = variant.title;
        if (addButton) addButton.disabled = !variant.available;
        if (mobileAdd) mobileAdd.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.sold;
        if (mobileAdd) mobileAdd.textContent = variant.available ? labels.add : labels.sold;
        if (availability) availability.textContent = variant.available ? labels.ready : labels.unavailable;
        const hasCuratedGallery = thumbs.some(thumb => thumb.hasAttribute('data-anchor-color'));
        const anchorIndex = hasCuratedGallery
          ? thumbs.findIndex(thumb => thumb.dataset.anchorColor === String(variant.options[0] || '').toLowerCase())
          : thumbs.findIndex(thumb => variant.mediaId && thumb.dataset.mediaId === String(variant.mediaId));
        if (syncGallery && anchorIndex >= 0) selectImage(anchorIndex);
        else if (syncGallery && !hasCuratedGallery && variant.image && heroImage) {
          heroImage.removeAttribute('srcset');
          heroImage.removeAttribute('sizes');
          heroImage.src = variant.image;
          heroImage.alt = variant.title;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id).split('/').pop());
        window.history.replaceState({}, '', url.toString());
      };

      optionInputs.forEach((input) => input.addEventListener('change', () => {
        updateVariant();
        updateFitInline();
      }));
      updateFitInline();
      const initialColor = section.querySelector('.alf-swatch input:checked');
      if (initialColor && variants[0]?.options[Number(initialColor.dataset.optionPosition) - 1] !== initialColor.value) updateVariant(false);

      // Add-to-cart: avoid a full-page redirect to /cart, and open the existing PagePilot
      // cart drawer instead, for every purchase path — including all Kaching Bundle tiers
      // (Buy 1 through Buy 4+). We first tried letting Kaching's real form submission happen
      // untouched but redirected into a hidden iframe, to avoid reimplementing anything
      // proprietary — but testing found that caused Meta Pixel's own shadow form-resubmission
      // (fbevents.js re-submits the same form into its own hidden iframe for tracking) to
      // become a second REAL /cart/add POST, doubling the quantity added.
      //
      // Confirmed with Kaching support, and verified directly in the DOM across all four
      // tiers, that a bundle tier here is just a plain quantity change on this SAME form:
      // selecting a tier only updates the form's "quantity" hidden input and its
      // "properties[__kaching_bundles]" hidden input (which carries that tier's discount/deal
      // id for Kaching's server-side pricing function) — there is no per-unit variant
      // selection or any other proprietary submission logic involved. So every tier is added
      // the same safe way: read the form's current id/quantity/bundle-properties at click
      // time and add via a single plain fetch to /cart/add.js, mirroring exactly what the
      // real native submission would have sent — no iframe, no redirect, nothing for Meta
      // Pixel's shadow resubmission to duplicate.
      const readBundleProperties = (form) => {
        const bundleField = form.querySelector('input[name="properties[__kaching_bundles]"]');
        if (!bundleField || !bundleField.value) return undefined;
        return { __kaching_bundles: bundleField.value };
      };

      const openCartDrawer = () => {
        const trigger = document.querySelector('pagepilot-cart-drawer-trigger button');
        if (trigger) {
          trigger.click();
          return true;
        }
        return false;
      };

      const addToCartAjax = async (id, quantity, properties) => {
        const item = { id, quantity };
        if (properties) item.properties = properties;
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!response.ok) {
          const errorBody = await response.json().catch(() => ({}));
          throw new Error(errorBody.description || 'add_to_cart_failed');
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      };

      const handleAddToCartClick = (event) => {
        event.preventDefault();
        const triggerButton = event.currentTarget;
        const form = triggerButton.form
          || document.getElementById(triggerButton.getAttribute('form'));
        const id = variantId ? variantId.value : null;
        if (!id || !form) return;
        const qtyField = form.querySelector('input[name="quantity"]');
        const quantity = (qtyField && parseInt(qtyField.value, 10)) || 1;
        const properties = readBundleProperties(form);
        const restoreAddButton = addLabel ? addLabel.textContent : '';
        const restoreMobileAdd = mobileAdd ? mobileAdd.textContent : '';
        if (addButton) addButton.disabled = true;
        if (mobileAdd) mobileAdd.disabled = true;
        addToCartAjax(id, quantity, properties)
          .then(() => {
            const opened = openCartDrawer();
            if (addLabel) addLabel.textContent = 'Added';
            if (mobileAdd) mobileAdd.textContent = 'Added';
            if (!opened && availability) availability.textContent = 'Added to your cart.';
            setTimeout(() => {
              updateVariant();
              if (addLabel && !addButton.disabled) addLabel.textContent = restoreAddButton;
              if (mobileAdd && !mobileAdd.disabled) mobileAdd.textContent = restoreMobileAdd;
            }, 2200);
          })
          .catch(() => {
            updateVariant();
            if (availability) availability.textContent = 'Something went wrong adding this to your cart. Please try again.';
          });
      };

      if (addButton) addButton.addEventListener('click', handleAddToCartClick);
      if (mobileAdd) mobileAdd.addEventListener('click', handleAddToCartClick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eunoia-purchase-r04"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-eunoia-purchase-r04]');
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const thumbs = Array.from(section.querySelectorAll('[data-gallery-index]'));
      const heroImage = section.querySelector('.alf-hero-image');
      const imageCount = section.querySelector('[data-gallery-count]');
      const galleryCache = new Map();
      let activeImage = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
      let imageRequest = 0;

      const preloadGalleryImage = (source) => {
        if (!source) return null;
        if (galleryCache.has(source)) return galleryCache.get(source);
        const image = new Image();
        image.decoding = 'async';
        image.src = source;
        galleryCache.set(source, image);
        return image;
      };

      const selectImage = (index) => {
        if (!thumbs.length || !heroImage) return;
        const next = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[next];
        const request = ++imageRequest;
        const highResolutionSource = thumb.dataset.src || '';
        const thumbnailImage = thumb.querySelector('img');
        const immediateSource = thumbnailImage?.currentSrc || thumbnailImage?.src || highResolutionSource;
        activeImage = next;
        heroImage.removeAttribute('srcset');
        heroImage.removeAttribute('sizes');
        if (immediateSource) heroImage.src = immediateSource;
        heroImage.alt = thumb.dataset.alt || '';
        imageCount.textContent = `${String(next + 1).padStart(2, '0')} / ${thumbs.length}`;
        thumbs.forEach((item, itemIndex) => {
          const selected = itemIndex === next;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

        const highResolutionImage = preloadGalleryImage(highResolutionSource);
        const showHighResolutionImage = () => {
          if (request !== imageRequest || activeImage !== next || !highResolutionSource) return;
          heroImage.src = highResolutionSource;
        };
        if (highResolutionImage?.complete && highResolutionImage.naturalWidth > 0) {
          showHighResolutionImage();
        } else {
          highResolutionImage?.addEventListener('load', showHighResolutionImage, { once: true });
        }

        preloadGalleryImage(thumbs[(next + 1) % thumbs.length]?.dataset.src);
        preloadGalleryImage(thumbs[(next - 1 + thumbs.length) % thumbs.length]?.dataset.src);
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => selectImage(activeImage - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectImage(activeImage + 1));
      preloadGalleryImage(thumbs[1]?.dataset.src);
      preloadGalleryImage(thumbs[thumbs.length - 1]?.dataset.src);

      const dialog = section.querySelector('[data-image-dialog]');
      section.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
        if (!dialog || !heroImage) return;
        const zoomedImage = dialog.querySelector('[data-zoomed-image]');
        zoomedImage.src = heroImage.currentSrc || heroImage.src;
        zoomedImage.alt = heroImage.alt;
        dialog.querySelector('[data-zoomed-caption]').textContent = imageCount.textContent;
        dialog.showModal();
      });
      dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());

      let variants = [];
      try {
        variants = JSON.parse(section.querySelector('[data-variant-json]')?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const fitInline = section.querySelector('[data-fit-inline]');
      const factChest = section.querySelector('[data-fact-chest]');
      const sizeFieldset = section.querySelector('.alf-size-option');
      const sizePosition = sizeFieldset ? sizeFieldset.dataset.optionPosition : null;
      const cmToIn = (cm) => (cm / 2.54).toFixed(1);

      const updateFitInline = () => {
        if (!sizePosition) return;
        const selected = section.querySelector(`[data-option-input][data-option-position="${sizePosition}"]:checked`)?.value;
        const row = selected ? Array.from(section.querySelectorAll('[data-size-row]')).find((item) => item.dataset.sizeRow === selected) : null;
        const measurements = row ? { chest: Number(row.dataset.chest), shoulder: Number(row.dataset.shoulder), sleeve: Number(row.dataset.sleeve), length: Number(row.dataset.length) } : null;
        if (fitInline) {
          fitInline.textContent = measurements
            ? `This size measures: ${(fitInline.dataset.measurementLabel || "Chest").toLowerCase()} ${measurements.chest}cm / ${cmToIn(measurements.chest)}in · shoulder ${measurements.shoulder}cm / ${cmToIn(measurements.shoulder)}in · sleeve ${measurements.sleeve}cm / ${cmToIn(measurements.sleeve)}in · length ${measurements.length}cm / ${cmToIn(measurements.length)}in`
            : 'Select a size to see its garment measurements.';
        }
        if (factChest) {
          factChest.textContent = measurements ? `${measurements.chest}cm / ${cmToIn(measurements.chest)}in` : 'Select a size';
        }
      };

      const optionInputs = Array.from(section.querySelectorAll('[data-option-input]'));
      const variantId = section.querySelector('[data-variant-id]');
      const price = section.querySelector('[data-product-price]');
      const comparePrice = section.querySelector('[data-compare-price]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const availability = section.querySelector('[data-availability]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const addLabel = section.querySelector('[data-add-label]');
      const mobileAdd = section.querySelector('[data-mobile-add]');
      const mobileSelection = section.querySelector('[data-mobile-selection]');
      const labels = {
        add: section.dataset.labelAdd,
        sold: section.dataset.labelSold,
        unavailable: section.dataset.labelUnavailable,
        ready: section.dataset.labelReady
      };

      const updateVariant = (syncGallery = true) => {
        const positions = Array.from(new Set(optionInputs.map((input) => Number(input.dataset.optionPosition)))).sort();
        const selected = positions.map((position) => section.querySelector(`[data-option-input][data-option-position="${position}"]:checked`)?.value || '');
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        optionInputs.forEach((input) => {
          const label = input.closest('label');
          if (label) label.classList.toggle('is-active', input.checked);
          if (input.checked) {
            const target = section.querySelector(`[data-option-name="${input.dataset.optionPosition}"]`);
            if (target) target.textContent = input.value;
          }
        });
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (mobileAdd) mobileAdd.disabled = true;
          if (addLabel) addLabel.textContent = labels.unavailable;
          if (availability) availability.textContent = labels.unavailable;
          return;
        }
        if (variantId) variantId.value = variant.id;
        if (price) price.textContent = variant.price;
        if (comparePrice) { comparePrice.textContent = variant.compareAt || ""; comparePrice.hidden = !variant.compareAt; }
        if (mobilePrice) mobilePrice.textContent = variant.price;
        if (mobileSelection) mobileSelection.textContent = variant.title;
        if (addButton) addButton.disabled = !variant.available;
        if (mobileAdd) mobileAdd.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.sold;
        if (mobileAdd) mobileAdd.textContent = variant.available ? labels.add : labels.sold;
        if (availability) availability.textContent = variant.available ? labels.ready : labels.unavailable;
        const hasCuratedGallery = thumbs.some(thumb => thumb.hasAttribute('data-anchor-color'));
        const anchorIndex = hasCuratedGallery
          ? thumbs.findIndex(thumb => thumb.dataset.anchorColor === String(variant.options[0] || '').toLowerCase())
          : thumbs.findIndex(thumb => variant.mediaId && thumb.dataset.mediaId === String(variant.mediaId));
        if (syncGallery && anchorIndex >= 0) selectImage(anchorIndex);
        else if (syncGallery && !hasCuratedGallery && variant.image && heroImage) {
          heroImage.removeAttribute('srcset');
          heroImage.removeAttribute('sizes');
          heroImage.src = variant.image;
          heroImage.alt = variant.title;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id).split('/').pop());
        window.history.replaceState({}, '', url.toString());
      };

      optionInputs.forEach((input) => input.addEventListener('change', () => {
        updateVariant();
        updateFitInline();
      }));
      updateFitInline();
      const initialColor = section.querySelector('.alf-swatch input:checked');
      if (initialColor && variants[0]?.options[Number(initialColor.dataset.optionPosition) - 1] !== initialColor.value) updateVariant(false);
      const readBundleProperties = (form) => {
        const bundleField = form.querySelector('input[name="properties[__kaching_bundles]"]');
        if (!bundleField || !bundleField.value) return undefined;
        return { __kaching_bundles: bundleField.value };
      };

      const openCartDrawer = () => {
        const trigger = document.querySelector('pagepilot-cart-drawer-trigger button');
        if (trigger) {
          trigger.click();
          return true;
        }
        return false;
      };

      const addToCartAjax = async (id, quantity, properties) => {
        const item = { id, quantity };
        if (properties) item.properties = properties;
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!response.ok) {
          const errorBody = await response.json().catch(() => ({}));
          throw new Error(errorBody.description || 'add_to_cart_failed');
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      };

      const handleAddToCartClick = (event) => {
        event.preventDefault();
        const triggerButton = event.currentTarget;
        const form = triggerButton.form
          || document.getElementById(triggerButton.getAttribute('form'));
        const id = variantId ? variantId.value : null;
        if (!id || !form) return;
        const qtyField = form.querySelector('input[name="quantity"]');
        const quantity = (qtyField && parseInt(qtyField.value, 10)) || 1;
        const properties = readBundleProperties(form);
        const restoreAddButton = addLabel ? addLabel.textContent : '';
        const restoreMobileAdd = mobileAdd ? mobileAdd.textContent : '';
        if (addButton) addButton.disabled = true;
        if (mobileAdd) mobileAdd.disabled = true;
        addToCartAjax(id, quantity, properties)
          .then(() => {
            const opened = openCartDrawer();
            if (addLabel) addLabel.textContent = 'Added';
            if (mobileAdd) mobileAdd.textContent = 'Added';
            if (!opened && availability) availability.textContent = 'Added to your cart.';
            setTimeout(() => {
              updateVariant();
              if (addLabel && !addButton.disabled) addLabel.textContent = restoreAddButton;
              if (mobileAdd && !mobileAdd.disabled) mobileAdd.textContent = restoreMobileAdd;
            }, 2200);
          })
          .catch(() => {
            updateVariant();
            if (availability) availability.textContent = 'Something went wrong adding this to your cart. Please try again.';
          });
      };

      if (addButton) addButton.addEventListener('click', handleAddToCartClick);
      if (mobileAdd) mobileAdd.addEventListener('click', handleAddToCartClick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                setCookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = setCookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-alfonso-r02"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-alfonso-r02]');
    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const thumbs = Array.from(section.querySelectorAll('[data-gallery-index]'));
      const heroImage = section.querySelector('.alf-hero-image');
      const imageCount = section.querySelector('[data-gallery-count]');
      const galleryCache = new Map();
      let activeImage = 0;
      let imageRequest = 0;

      const preloadGalleryImage = (source) => {
        if (!source) return null;
        if (galleryCache.has(source)) return galleryCache.get(source);
        const image = new Image();
        image.decoding = 'async';
        image.src = source;
        galleryCache.set(source, image);
        return image;
      };

      const selectImage = (index) => {
        if (!thumbs.length || !heroImage) return;
        const next = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[next];
        const request = ++imageRequest;
        const highResolutionSource = thumb.dataset.src || '';
        const thumbnailImage = thumb.querySelector('img');
        const immediateSource = thumbnailImage?.currentSrc || thumbnailImage?.src || highResolutionSource;
        activeImage = next;
        heroImage.removeAttribute('srcset');
        heroImage.removeAttribute('sizes');
        if (immediateSource) heroImage.src = immediateSource;
        heroImage.alt = thumb.dataset.alt || '';
        imageCount.textContent = `${String(next + 1).padStart(2, '0')} / ${thumbs.length}`;
        thumbs.forEach((item, itemIndex) => {
          const selected = itemIndex === next;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

        const highResolutionImage = preloadGalleryImage(highResolutionSource);
        const showHighResolutionImage = () => {
          if (request !== imageRequest || activeImage !== next || !highResolutionSource) return;
          heroImage.src = highResolutionSource;
        };
        if (highResolutionImage?.complete && highResolutionImage.naturalWidth > 0) {
          showHighResolutionImage();
        } else {
          highResolutionImage?.addEventListener('load', showHighResolutionImage, { once: true });
        }

        preloadGalleryImage(thumbs[(next + 1) % thumbs.length]?.dataset.src);
        preloadGalleryImage(thumbs[(next - 1 + thumbs.length) % thumbs.length]?.dataset.src);
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => selectImage(activeImage - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectImage(activeImage + 1));
      preloadGalleryImage(thumbs[1]?.dataset.src);
      preloadGalleryImage(thumbs[thumbs.length - 1]?.dataset.src);

      const dialog = section.querySelector('[data-image-dialog]');
      section.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
        if (!dialog || !heroImage) return;
        const zoomedImage = dialog.querySelector('[data-zoomed-image]');
        zoomedImage.src = heroImage.currentSrc || heroImage.src;
        zoomedImage.alt = heroImage.alt;
        dialog.querySelector('[data-zoomed-caption]').textContent = imageCount.textContent;
        dialog.showModal();
      });
      dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());

      let variants = [];
      try {
        variants = JSON.parse(section.querySelector('[data-variant-json]')?.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const sizeMeasurements = {
        'XS': { chest: 96, shoulder: 40, sleeve: 57 },
        'S': { chest: 100, shoulder: 42, sleeve: 58 },
        'M': { chest: 104, shoulder: 44, sleeve: 59 },
        'L': { chest: 108, shoulder: 46, sleeve: 60 },
        'XL': { chest: 112, shoulder: 47, sleeve: 61 },
        '2XL': { chest: 116, shoulder: 48, sleeve: 61 }
      };
      const fitInline = section.querySelector('[data-fit-inline]');
      const factChest = section.querySelector('[data-fact-chest]');
      const sizeFieldset = section.querySelector('.alf-size-option');
      const sizePosition = sizeFieldset ? sizeFieldset.dataset.optionPosition : null;
      const cmToIn = (cm) => (cm / 2.54).toFixed(1);

      const updateFitInline = () => {
        if (!sizePosition) return;
        const selected = section.querySelector(`[data-option-input][data-option-position="${sizePosition}"]:checked`)?.value;
        const measurements = selected ? sizeMeasurements[selected] : null;
        if (fitInline) {
          fitInline.textContent = measurements
            ? `This size measures: chest ${measurements.chest}cm / ${cmToIn(measurements.chest)}in · shoulder ${measurements.shoulder}cm / ${cmToIn(measurements.shoulder)}in · sleeve ${measurements.sleeve}cm / ${cmToIn(measurements.sleeve)}in`
            : 'Select a size to see its garment measurements.';
        }
        if (factChest) {
          factChest.textContent = measurements ? `${measurements.chest}cm / ${cmToIn(measurements.chest)}in` : 'Select a size';
        }
      };

      const optionInputs = Array.from(section.querySelectorAll('[data-option-input]'));
      const variantId = section.querySelector('[data-variant-id]');
      const price = section.querySelector('[data-product-price]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const availability = section.querySelector('[data-availability]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const addLabel = section.querySelector('[data-add-label]');
      const mobileAdd = section.querySelector('[data-mobile-add]');
      const mobileSelection = section.querySelector('[data-mobile-selection]');
      const labels = {
        add: section.dataset.labelAdd,
        sold: section.dataset.labelSold,
        unavailable: section.dataset.labelUnavailable,
        ready: section.dataset.labelReady
      };

      const updateVariant = () => {
        const positions = Array.from(new Set(optionInputs.map((input) => Number(input.dataset.optionPosition)))).sort();
        const selected = positions.map((position) => section.querySelector(`[data-option-input][data-option-position="${position}"]:checked`)?.value || '');
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        optionInputs.forEach((input) => {
          const label = input.closest('label');
          if (label) label.classList.toggle('is-active', input.checked);
          if (input.checked) {
            const target = section.querySelector(`[data-option-name="${input.dataset.optionPosition}"]`);
            if (target) target.textContent = input.value;
          }
        });
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (mobileAdd) mobileAdd.disabled = true;
          if (addLabel) addLabel.textContent = labels.unavailable;
          if (availability) availability.textContent = labels.unavailable;
          return;
        }
        if (variantId) variantId.value = variant.id;
        if (price) price.textContent = variant.price;
        if (mobilePrice) mobilePrice.textContent = variant.price;
        if (mobileSelection) mobileSelection.textContent = variant.title;
        if (addButton) addButton.disabled = !variant.available;
        if (mobileAdd) mobileAdd.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.sold;
        if (mobileAdd) mobileAdd.textContent = variant.available ? labels.add : labels.sold;
        if (availability) availability.textContent = variant.available ? labels.ready : labels.unavailable;
        if (variant.image && heroImage) {
          heroImage.removeAttribute('srcset');
          heroImage.removeAttribute('sizes');
          heroImage.src = variant.image;
          heroImage.alt = variant.title;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id).split('/').pop());
        window.history.replaceState({}, '', url.toString());
      };

      optionInputs.forEach((input) => input.addEventListener('change', () => {
        updateVariant();
        updateFitInline();
      }));
      updateFitInline();

      // Add-to-cart: avoid a full-page redirect to /cart, and open the existing PagePilot
      // cart drawer instead, for every purchase path — including all Kaching Bundle tiers
      // (Buy 1 through Buy 4+). We first tried letting Kaching's real form submission happen
      // untouched but redirected into a hidden iframe, to avoid reimplementing anything
      // proprietary — but testing found that caused Meta Pixel's own shadow form-resubmission
      // (fbevents.js re-submits the same form into its own hidden iframe for tracking) to
      // become a second REAL /cart/add POST, doubling the quantity added.
      //
      // Confirmed with Kaching support, and verified directly in the DOM across all four
      // tiers, that a bundle tier here is just a plain quantity change on this SAME form:
      // selecting a tier only updates the form's "quantity" hidden input and its
      // "properties[__kaching_bundles]" hidden input (which carries that tier's discount/deal
      // id for Kaching's server-side pricing function) — there is no per-unit variant
      // selection or any other proprietary submission logic involved. So every tier is added
      // the same safe way: read the form's current id/quantity/bundle-properties at click
      // time and add via a single plain fetch to /cart/add.js, mirroring exactly what the
      // real native submission would have sent — no iframe, no redirect, nothing for Meta
      // Pixel's shadow resubmission to duplicate.
      const readBundleProperties = (form) => {
        const bundleField = form.querySelector('input[name="properties[__kaching_bundles]"]');
        if (!bundleField || !bundleField.value) return undefined;
        return { __kaching_bundles: bundleField.value };
      };

      const openCartDrawer = () => {
        const trigger = document.querySelector('pagepilot-cart-drawer-trigger button');
        if (trigger) {
          trigger.click();
          return true;
        }
        return false;
      };

      const addToCartAjax = async (id, quantity, properties) => {
        const item = { id, quantity };
        if (properties) item.properties = properties;
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!response.ok) {
          const errorBody = await response.json().catch(() => ({}));
          throw new Error(errorBody.description || 'add_to_cart_failed');
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      };

      const handleAddToCartClick = (event) => {
        event.preventDefault();
        const triggerButton = event.currentTarget;
        const form = triggerButton.form
          || document.getElementById(triggerButton.getAttribute('form'));
        const id = variantId ? variantId.value : null;
        if (!id || !form) return;
        const qtyField = form.querySelector('input[name="quantity"]');
        const quantity = (qtyField && parseInt(qtyField.value, 10)) || 1;
        const properties = readBundleProperties(form);
        const restoreAddButton = addLabel ? addLabel.textContent : '';
        const restoreMobileAdd = mobileAdd ? mobileAdd.textContent : '';
        if (addButton) addButton.disabled = true;
        if (mobileAdd) mobileAdd.disabled = true;
        addToCartAjax(id, quantity, properties)
          .then(() => {
            const opened = openCartDrawer();
            if (addLabel) addLabel.textContent = 'Added';
            if (mobileAdd) mobileAdd.textContent = 'Added';
            if (!opened && availability) availability.textContent = 'Added to your cart.';
            setTimeout(() => {
              updateVariant();
              if (addLabel && !addButton.disabled) addLabel.textContent = restoreAddButton;
              if (mobileAdd && !mobileAdd.disabled) mobileAdd.textContent = restoreMobileAdd;
            }, 2200);
          })
          .catch(() => {
            updateVariant();
            if (availability) availability.textContent = 'Something went wrong adding this to your cart. Please try again.';
          });
      };

      if (addButton) addButton.addEventListener('click', handleAddToCartClick);
      if (mobileAdd) mobileAdd.addEventListener('click', handleAddToCartClick);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
